<template>
  <div class="pb-2">
    <div
      class="border-b border-border flex items-center"
    >
      <div class="text-primary-500 font-semibold text-base mx-4 my-3">
        Rychlý náhled
      </div>
      <small
        class="text-text-light text-sm font-normal ml-3"
      >
        {{ requests.length }} {{ pluralize(requests.length, 'požadavek', 'požadavky', 'požadavků') }}
      </small>
    </div>
    <div class="overflow-auto max-h-[40vh]">
      <transition-group name="list">
        <OperatorRequestRow
          v-for="request in requests"
          :key="request.id"
          :request="request"
          quick-preview
          type="open"
          class="RequestRow"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    requests: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.RequestRow {
  border-bottom: 1px solid var(--color-border);
  box-shadow: none;
  margin-bottom: 0;
}
</style>
